import React from 'react';
import StockForm from './stock/StockForm';

const AddStockPage: React.FC = () => (
    <div className="padding">
        <StockForm />
    </div>
)

export default AddStockPage;
